import { Badge } from '@safetyhub/ui';
import { getMemberKindBadgeTone, getMemberKindLabel, memberKindOf } from '../lib/organizations';

interface RoleBadgeProps {
  /** 멤버 행 — 서버가 실은 `isOwner`·`countsAsMember`로 종류를 가른다(P7-b-2, 옛 `role` prop 대체) */
  member: { isOwner?: boolean; countsAsMember?: boolean };
}

/**
 * 멤버 종류 배지 — 조직소유자 / 구성원 / 외부 인원.
 * 공용 `Badge`의 알약 모양으로 표시. 구체 역할 이름(안전관리자·관리감독자…)은 역할·선임 화면이 보여 준다.
 *
 * 사용 예시:
 * <RoleBadge member={member} />
 */
export function RoleBadge({ member }: RoleBadgeProps) {
  const kind = memberKindOf(member);
  return <Badge tone={getMemberKindBadgeTone(kind)}>{getMemberKindLabel(kind)}</Badge>;
}

export default RoleBadge;
